import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FallbackImages, {
  type FallbackOption, type FallbackImageProps,
} from '../../utils/fallback-images';

interface FallbackUI {
  readonly heading?: string;
  readonly description?: string;
  readonly Image: FallbackImageProps;
}

export default function FallbackImage({ heading, description, Image }: FallbackUI) {
  const ImageComponent = FallbackImages[Image.src as FallbackOption];

  return (
    <Stack alignItems="center" justifyContent="center" width="100%">
      <Stack justifyContent="center" mb={2.5} width={Image.width ?? '100%'} height={Image.height ?? '100%'}>
        <ImageComponent width="100%" height="100%" />
      </Stack>
      {heading && <Typography variant="h3" mb={1}>{heading}</Typography>}
      {description && <Typography>{description}</Typography>}
    </Stack>
  );
}
